import { useState } from "react";
import colorSharp from "../assets/images/color-sharp.png";

const skills = [
  { name: "Test Automation", icon: "🤖", percent: 92 },
  { name: "Web Development", icon: "🌐", percent: 80 },
  { name: "Mobile App Dev", icon: "📱", percent: 75 },
  { name: "HCI Research", icon: "🔬", percent: 85 },
  { name: "Data Analysis", icon: "📊", percent: 78 },
  { name: "Java & Spring Boot", icon: "☕", percent: 88 },
  { name: "API Testing", icon: "🔗", percent: 90 },
  { name: "Performance Testing", icon: "⚡", percent: 82 },
  { name: "Problem Solving", icon: "🧠", percent: 95 },
  { name: "Python", icon: "🐍", percent: 76 },
  { name: "React", icon: "⚛️", percent: 72 },
  { name: "CI/CD", icon: "🔄", percent: 80 },
];

const SkillCard = ({ skill }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className={`skill-flip-card${flipped ? " flipped" : ""}`}
      onClick={() => setFlipped(!flipped)}
    >
      <div className="skill-flip-inner">
        <div className="skill-flip-front">
          <span className="skill-icon">{skill.icon}</span>
          <span>{skill.name}</span>
        </div>
        <div className="skill-flip-back">
          <span className="skill-percent">{skill.percent}%</span>
          <span className="skill-back-label">{skill.name}</span>
          <div className="skill-bar-track">
            <div className="skill-bar-fill" style={{ width: `${skill.percent}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const Skills = () => {
  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx">
              <span className="skill-label">What I Bring</span>
              <h2>Skills & Expertise</h2>
              <p>
                From automating test pipelines to building full-stack web and mobile apps,
                I blend engineering precision with research curiosity. My stack spans Java,
                Python, React, and a wide range of automation and data analysis tools.
              </p>
              <p className="skill-hint">Click a skill to see proficiency</p>
              <div className="skill-tags">
                {skills.map((skill, i) => (
                  <SkillCard skill={skill} key={i} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};
